import TextUtil from "../../../../../shared/lib/html5-software-library/src/ranj/components/text/TextUtil";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import GameConfig from "../model/GameConfig";
import TutorialOverlayMediatorEvent from "../model/TutorialOverlayMediatorEvent";
import TutorialPlayerEvent from "../model/TutorialPlayerEvent";

export default class TutorialOverlayMediator extends AbstractPopupMediator {

    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {somajs.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {GameConfig} gameConfig 
     */
    constructor(target, dispatcher, languagePack, layoutManager, gameConfig) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;
    }


    initialize() {
        super.initialize();
        this._setPage(0);

        this.registerEventListener(TutorialPlayerEvent.NEXT_STEP, this._handleNextTutorialStep.bind(this));

        if (ranj.DEBUG) {
            this._handleKeyUp = this._handleKeyUp.bind(this);
            window.document.addEventListener('keyup', this._handleKeyUp);
        }
    }

    destroy() {
        super.destroy();
        if (ranj.DEBUG) {
            window.document.removeEventListener('keyup', this._handleKeyUp);
        }
    }

    _handleKeyUp(e) {
        const c = String.fromCharCode(e.which);
        if (c == "X") this._changePage(99);
    }

    _handleNextTutorialStep(evt) {
        const stepIndex = evt.params.data.stepIndex;
        this._setPage(stepIndex);
    }


    _changePage(delta) {
        const f = Math.max(0, this._target.currentFrame + delta);
        const n = this._target.totalFrames;
        if (f >= n) {
            this.close();
        } else {
            const duration = this._gameConfig.getValue("tutorial.crossFadeDuration");
            const wait = this._gameConfig.getValue("tutorial.crossFadeDelay");
            createjs.Tween.get(this._target)
                .to({ alpha: 0 }, duration, createjs.Ease.quadOut)
                .call(() => {
                    this._setPage(f);
                })
                .wait(wait)
                .to({ alpha: 1 }, duration, createjs.Ease.quadIn);
        }
    }

    _setPage(idx) {
        this._target.gotoAndStop(idx);

        const prefix = `tutorial.overlay${idx}.`;

        const step = this._target[`step${idx}`];

        const titleTextField = step.titleTextfield;
        if (titleTextField) {
            this.applyText(titleTextField, this.getText(prefix + "title"));
        }

        const bodyTextField = step.bodyTextfield;
        if (bodyTextField) {
            this.applyText(bodyTextField, this.getText(prefix + "body"));
        }

        const actionTextField = step.actionTextfield;
        if (actionTextField) {
            const actionTextFieldHeight = actionTextField.getBounds().height;
            this.applyText(actionTextField, this.getText(prefix + "action"));
            TextUtil.alignBottom(actionTextField, actionTextFieldHeight);
        }

        const startButtonSkin = step.startButton;
        if (startButtonSkin) {
            if (this._startButton) {
                this._startButton.destroy();
                this._startButton = null;
            }

            const startButtonLabel = this.getText(prefix + "startButton");
            this._startButton = this.createButton(startButtonSkin, () => {
                this._startButton.setEnabled(false);
                this.dispatch(TutorialOverlayMediatorEvent.CONTINUE_BUTTON_CLICKED);
            }, startButtonLabel);
        }

        const replayButtonSkin = step.replayButton;
        if (replayButtonSkin) {
            if (this._replayButton) {
                this._replayButton.destroy();
            }

            const replayButtonLabel = this.getText(prefix + "replayButton");
            this._replayButton = this.createButton(replayButtonSkin, () => {
                this._replayButton.setEnabled(false);
                this.dispatch(TutorialOverlayMediatorEvent.REPLAY_BUTTON_CLICKED);
            });

            this._replayButton.setCenteredLabel(replayButtonLabel);
        }

        const overlaySkin = step.overlay;
        if (overlaySkin) {
            if (this._overlayButton) {
                this._overlayButton.destroy();
                this._overlayButton = null;
            }

            this._overlayButton = this.createButton(overlaySkin, () => {
                // eat click
            });

            overlaySkin.cursor = "default";
        }
    }
}